import { Portal } from '@shared/layouts/portal/portal'
import cn from 'classnames'

import { useToastList } from '../../model/redux-toast.store'
import { Toast } from '../toast/toast'

import styles from './toast-container.module.css'

type ToastContainerProps = {
  className?: string
  position?: 'top-right' | 'top-left' | 'bottom-left' | 'bottom-right'
}

export const ToastContainer = ({
  className,
  position = 'top-right'
}: ToastContainerProps) => {
  const { items: toasts } = useToastList()
  const containerCls = cn(styles.container, className, {
    [styles.topRight]: position === 'top-right',
    [styles.topLeft]: position === 'top-left',
    [styles.bottomRight]: position === 'bottom-right',
    [styles.bottomLeft]: position === 'bottom-left'
  })

  const isLeftSide = position === 'top-left' || position === 'bottom-left'
  return (
    <Portal>
      <div className={containerCls}>
        {toasts.map((toast) => (
          <Toast
            toast={toast}
            key={toast.id}
            side={isLeftSide ? 'left' : 'right'}
          />
        ))}
      </div>
    </Portal>
  )
}
